import { useCallback } from 'react';
import { UnseenIndicator } from './unseenCount/UnseenIndicator';
import { useUnseenCountText } from './unseenCount/useUnseenCountText';
import { DELIVERY_METHOD_NAMES } from '../constants';
import { useLoadNotificationsComponent } from '../services/RealTimeNotificationHandlers/hooks';
import { useTranslation } from '../../../hooks/useNavConfig';
import memoWithDisplayName from '../../../utils/memoWithDisplayName';
import { GlobalToolbarButton } from '../../../components/GlobalToolbar/Components/GlobalToolbarButton';
import { ICON_NAMES } from '../../../components/GlobalToolbar/Components/GlobalToolbarIcon';
import { useNotifications } from '../hooks';
import { jsx as _jsx } from "react/jsx-runtime";
/**
 * Notifications global toolbar button enriched with unseen notifications count
 */
export const NotificationsButtonComponent = ({
  isNotificationsOpen,
  onClick
}) => {
  const toggleComponentOn = useLoadNotificationsComponent();
  const toggleSidebarOn = useCallback(() => {
    toggleComponentOn(DELIVERY_METHOD_NAMES.SIDEBAR);
  }, [toggleComponentOn]);
  const {
    t
  } = useTranslation();
  const {
    unseenCountText,
    notificationsButtonCountBadge
  } = useUnseenCountText();
  const label = unseenCountText ? t('nav.icons.notifications_unseen', {
    unseenCount: unseenCountText
  }) : t('nav.icons.notifications');
  const onBellClick = useCallback(() => {
    toggleSidebarOn();
    onClick();
  }, [toggleSidebarOn, onClick]);
  return /*#__PURE__*/_jsx(UnseenIndicator, {
    children: /*#__PURE__*/_jsx(GlobalToolbarButton, {
      id: "hs-global-toolbar-notifications-list-item",
      "data-test-id": "hs-global-toolbar-notifications-list-item",
      itemName: "Notifications",
      ariaControls: "notification-sidebar-iframe",
      iconName: ICON_NAMES.NOTIFICATIONS,
      ariaLabel: label,
      ariaExpanded: isNotificationsOpen,
      onClick: onBellClick,
      onFocus: toggleSidebarOn // optimistic head start assuming the sidebar will be opened
      ,
      onMouseDown: toggleSidebarOn // optimistic head start assuming the sidebar will be opened
      ,
      onMouseEnter: toggleSidebarOn // optimistic head start assuming the sidebar will be opened
      ,
      notificationsButtonCountBadge: notificationsButtonCountBadge
    })
  });
};
export const NotificationsButton = memoWithDisplayName('NotificationsButton', () => {
  const [isNotificationsOpen, notificationsOnClick] = useNotifications();
  return /*#__PURE__*/_jsx(NotificationsButtonComponent, {
    isNotificationsOpen: isNotificationsOpen,
    onClick: notificationsOnClick
  });
});